import React, { useContext } from 'react';
import { Layer, Stage, Text } from 'react-konva';
import ViewImage from './ViewImage';
import CallToAction from './CallToAction';
import Gif from './Gif';
import Rects from './Rect';
import Video from './Video';
import { ViewCardContext } from '../ViewCardContext';

const CardPage = ({ stage, pageData, pageId }) => {
  const viewCardContextValue = useContext(ViewCardContext);

  return (
    <Stage
      ref={(ref) => {
        if (ref) {
          ref.getStage().container().style.backgroundColor = 'white';
          ref.getStage().container().style.backfaceVisibility = 'hidden';
          ref.getStage().container().style.overflow = 'hidden';
        }
      }}
      // style={style}
      {...stage}
    >
      <ViewCardContext.Provider value={viewCardContextValue}>
        <Layer ref={(ref) => ref?.getLayer().listening(false)} id={`layer${pageId}`} key={pageId}>
          {pageData?.rects?.map((rectProps, ind) => (
            <Rects key={ind} rectProps={rectProps} />
          ))}
          {pageData?.images?.map((image, ind) => (
            <ViewImage imageObj={image} ind={ind} key={ind} />
          ))}
          {pageData?.videos?.map((videoProps, ind) => (
            <Video key={ind} videoProps={videoProps} />
          ))}
          {pageData?.gifs?.map((gifProps, ind) => (
            <Gif key={ind} gifProps={gifProps} />
          ))}
          {pageData?.textBoxes?.map(({ height, ...txbox }, ind) => (
            // no fixed height: text auto-sizes as in the editor (UText), so a wrapping merge tag value is not cut off
            <Text key={ind} listening={false} perfectDrawEnabled={false} {...txbox} draggable={false} />
          ))}
          {pageData?.ctas?.map((ctaProps, ind) => (
            <CallToAction key={ind} ctaProps={ctaProps} />
          ))}
        </Layer>
      </ViewCardContext.Provider>
    </Stage>
  );
};

export default React.memo(CardPage);
